import { handleApiError } from 'utils/api';
import { env } from '../../constants';
import { CreateCvRequest, CreateCvResponse, GetCvResponse } from './api-types';

const CV_URL = `${env.VITE_API_BASE_URL}/curriculumVitaes`;

export const fetchCv = async (
  token: string | undefined
): Promise<GetCvResponse | undefined | null> => {
  if (!token) {
    return undefined;
  }

  const response = await fetch(CV_URL, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  if (!response.ok) {
    if ([401, 503].includes(response.status)) {
      window.location.reload();
      return undefined;
    }
    if (response.status === 400) {
      const cloned = response.clone();
      const body = (await cloned.json()) as { code?: string };
      if (body?.code === 'error.cv.not-found') {
        return null;
      }
      await handleApiError(response);
    }
    throw Error('Could not fetch CV');
  }

  return response.json() as Promise<GetCvResponse>;
};

export const createCv = async (
  token: string | undefined,
  payload: CreateCvRequest
): Promise<CreateCvResponse | undefined> => {
  if (!token) {
    return undefined;
  }

  const response = await fetch(CV_URL, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    if ([401, 503].includes(response.status)) {
      window.location.reload();
      return undefined;
    }
    if (response.status === 400) {
      await handleApiError(response);
    } else throw Error('Could not create CV');
  }

  return response.json() as Promise<CreateCvResponse>;
};

export const updateCv = async (
  token: string | undefined,
  payload: CreateCvRequest
): Promise<null | undefined> => {
  if (!token) {
    return undefined;
  }

  const response = await fetch(CV_URL, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    if ([401, 503].includes(response.status)) {
      window.location.reload();
      return undefined;
    }
    if (response.status === 400) {
      await handleApiError(response);
    } else throw Error('Could not update CV');
  }

  return null;
};

export const deleteCv = async (
  token: string | undefined
): Promise<null | undefined> => {
  if (!token) {
    return undefined;
  }

  const response = await fetch(CV_URL, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  if (!response.ok) {
    if ([401, 503].includes(response.status)) {
      window.location.reload();
      return undefined;
    }
    if (response.status === 400) {
      await handleApiError(response);
    } else throw Error('Could not delete CV');
  }

  return null;
};
